export const BrandLogo = ({ size = "md", className = "", light = false }) => {
  const dims = { sm: "h-7 w-7", md: "h-9 w-9", lg: "h-12 w-12" }[size] || "h-9 w-9";
  const text = { sm: "text-lg", md: "text-xl", lg: "text-2xl" }[size] || "text-xl";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img src="/icon-192.png" alt="Mission Companion" className={`${dims} rounded-xl shadow-sm`} />
      <span className={`font-heading font-bold ${text} tracking-tight ${light ? "text-white" : "text-[var(--brand-navy)]"}`}>
        Mission Companion
      </span>
    </div>
  );
};

export default BrandLogo;
